export default __webpack_public_path__ + "static/media/capture-app.c8381b62.png";